// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"206":"983fe584aa1ca9a0c7c7","656":"0feff79bab0ee91359d6","781":"a8b2c48e3d56cccfb959"}[chunkId] + ".chunk.js";
};